var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#F72585",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8448 11.9005L30.8443 11.9H30.8026H15.1974C13.9307 11.9 12.9 12.9305 12.9 14.1974V29.8026C12.9 31.0693 13.9305 32.1 15.1974 32.1H30.8026C32.0693 32.1 33.1 31.0695 33.1 29.8026V14.1974C33.1 12.9447 32.0922 11.923 30.8448 11.9005ZM32.1769 29.8024C32.1769 30.5603 31.5603 31.1769 30.8025 31.1769L15.1972 31.1767C14.4393 31.1767 13.8227 30.5601 13.8227 29.8023L13.8229 14.197C13.8229 13.4391 14.4395 12.8225 15.1974 12.8225H30.8026C31.5605 12.8225 32.1771 13.4392 32.1771 14.197L32.1769 29.8024Z",
    fill: "#F72585",
    stroke: "#F72585",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9788 16.3071V16.2071H24.8788H21.1211H21.0211V16.3071V20.021H17.3073H17.2073V20.121V23.8786V23.9786H17.3073H21.0211V27.6924V27.7924H21.1211H24.8787H24.9787L24.9787 27.6924L24.9788 23.9787H28.6927H28.7927V23.8787V20.121V20.021H28.6927H24.9788L24.9788 16.3071ZM21.844 23.0559H18.1301V20.9441H21.844H21.944V20.8441V17.1301H24.0558V20.844V20.944H24.1558L27.8698 20.944V23.0558L24.156 23.0559L24.056 23.0559V23.1559V26.8698H21.9442L21.944 23.1559L21.944 23.0559H21.844Z",
    fill: "#F72585",
    stroke: "#F72585",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmo);
export default __webpack_public_path__ + "static/media/hmo.8295dba66f0d056c8aa2b7a1d190aeb3.svg";
export { ForwardRef as ReactComponent };